<template>
  <div class="container" >
       <div class="top">
           <div class="topItem">
                <div class="topItemLeft">
                    <span class="topItemLeft_span1">*</span>
                    <span class="topItemLeft_span2">抬头类型</span>
                </div>
                 <div class="topItemRight">
                     <div  v-if="receiptType !=2" class="selectItem_dot" @click="changeSelect(2)" ></div>
                     <img v-else class="selectItem_icon" :src="require(`../../assets/images/icon_check_${common.theme}.png`)" />
                     <span class="selectItem_span" >企业单位</span>
                     <div  v-if="receiptType ==2"  class="selectItem_dot" @click="changeSelect(1)"></div>
                     <img v-else class="selectItem_icon" :src="require(`../../assets/images/icon_check_${common.theme}.png`)"  />
                     <span class="selectItem_span">个人</span>
                 </div>
           </div>
           <div class="itemLine"></div>
           <div class="topItem">
                <div class="topItemLeft">
                    <span class="topItemLeft_span1">*</span>
                    <span class="topItemLeft_span2">名称</span>
                </div>
                 <div class="topItemRight">
                     <input @input="input" class="input" type="text" placeholder="填写发票抬头" @focus="focus" @blur="blur" v-model.trim="receiptTitle" maxlength='30' />
                     <div v-if="isInInput &&receiptTitle" class="closeDiv">
                         <img @click="clear" class="closeImage" src="../../assets/images/btn_clear.png" />
                     </div>
                 </div>
           </div>
           <div class="itemLine" ></div>
           <div class="topItem" v-if="receiptType ==2" >
                <div class="topItemLeft">
                    <span class="topItemLeft_span1">*</span>
                    <span class="topItemLeft_span2">税号</span>
                </div>
                <div class="topItemRight">
                     <input class="input" type="text" placeholder="填写纳税人识别号" @blur="blur" v-model.trim="ratepayingNumber" maxlength='30' />
                </div>
           </div>
           <div class="itemLine" v-if="receiptType ==2"></div>
              <div class="topItem" >
                 <span class="kaipiaoMsg">请仔细核对开票信息，以免影响您发票使用进度。</span>
              </div>
           <div v-if="receiptType==2 && isInInput &&resultList.length>0" class="popView" >
                <scroll class="scroll" :pullup="false" :pulldown="false" >
                    <div class="scrollItem" v-for="(item,index) in resultList" :key="index" @click="chooseReceipt(item)">
                        <span class="scrollItem_span">{{item.enterpriseName}}</span>
                    </div>
                </scroll>
                <div class="scrollBn" @click="isInInput=false"></div>
           </div>
       </div>

       <div class="itemButton">
           <span class="invoicebutton" v-if="valadateParams()" @click="saveAction">确认</span>
           <span class="buttonGy" v-else>确认</span>
       </div>
  </div>
</template>
<script>
import util from "@/utils/util";
import Scroll from "@/components/scroll";
import {receiptApisearchByName,updateMeetingOrder} from "@/utils/api";
import {mapState} from 'vuex';
export default {
    data(){
        return {
            orderNo:'',// 订单编号
            receiptType:2 ,// 开票类型（整型）：1、个人/非企业单位；2、企业单位
            receiptTitle:'',// 开票名称
            ratepayingNumber:'',// 纳税人识别号
            isInInput:false,
            resultList:[],
        }
    },
    components:{
        Scroll,
    },
    computed: {
        ...mapState({
            common: state => state.common
        })
    },
    created(){
        this.orderNo = this.$route.query.id;
        var   query = this.$route.query;

        if( query.receiptType){
            this.receiptType = query.receiptType
        }else{
            this.receiptType =2;
        }
            if( query.receiptTitle){
            this.receiptTitle = query.receiptTitle
        }
        if( query.ratepayingNumber){
            this.ratepayingNumber = query.ratepayingNumber
        }
    },

    methods:{
         changeSelect(index){
            this.receiptType =index;
            this.receiptTitle ='';
            this.ratepayingNumber ='';
            this.resultList =[];
         },
         clear(){
             this.receiptTitle ='';
             this.ratepayingNumber ='';
             this.resultList =[];
         },
         chooseReceipt(item){
             this.receiptTitle =item.enterpriseName
             this.ratepayingNumber =item.regNo
             this.isInInput =false;
         },
         blur(e){
            // this.isInInput =false;
         },
         focus(e){
              this.isInInput =true;
         },
         input(e){
                var self =this;
                console.log(JSON.stringify(e));
                console.log(JSON.stringify(this.receiptTitle));

                if(this.receiptType==2 && this.receiptTitle && this.receiptTitle.length>3){
                    var  params = {
                        companyName:this.receiptTitle,
                    }
                    receiptApisearchByName(params).then(res => {
                        if(res.res.code=='10000' ) {
                            if(res.body!=undefined && res.body!=null) {
                                self.resultList = res.body;
                                console.log("ret.body === " + JSON.stringify(self.resultList));
                            }
                        }else {
                          //  self.resultList =[];
                        }

                    })

                }else if(this.receiptType==2 && this.receiptTitle && this.receiptTitle.length<3){
                    self.resultList = [];
                }
         },
         valadateParams(){
             if(!this.receiptTitle){
                 return false;
             }
             if(this.receiptType ==2 && !this.ratepayingNumber){
                 return false;
             }

             return true;
         },

         saveAction(){
             //updateMeetingOrder
                    var  params = {
                        orderNo :this.orderNo,
                        receiptType:this.receiptType,// 开票类型（整型）：1、个人/非企业单位；2、企业单位
                        receiptTitle:this.receiptTitle,// 开票名称
                        ratepayingNumber:this.ratepayingNumber,// 纳税人识别号
                    }
                    util.showLoading('保存中...');
                    updateMeetingOrder(params).then(res => {
                        util.hideLoading()
                        if(res.res.code=='10000' ){
                            this.$router.go(-1);
                        }else{
                            util.showToast(res.res.msg)
                        }
                    })
         },

    }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container{
   // height:100vh;
    background:#F4F3F2;
}
.top{
    width: 100%;
    position: relative;
    flex-direction: column;
    background-color: #ffffff;
}
.popView{
    position: absolute;
    width: 100%;
    height: 400px;
    background-color: white;
    top: 210px;
    left: 0px;
}
.scroll{
     flex: 1;
     height: 326px;
     margin-bottom: 10px;
     flex-direction: column;
}
.scrollBn{
    height: 750px;
    width: 100%;
}
.scrollItem{
    margin-left: 220px;
    display: flex;
    width: 530px;
    padding-top: 20px;
    padding-bottom: 20px;
    flex-direction: row;
    align-items: center;
     border-bottom: 1px solid rgba(234,234,234,1);
}
.scrollItem_span{
    font-size:28px;
    color:rgba(51,51,51,1);
    line-height:40px;
}
.topItem{
    width: 100%;
    height: 100px;
    flex-direction: row;
    display: flex;
}
.topItemLeft{
    width: 220px;
    height: 100px;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.topItemLeft_span1{
    margin-left: 28px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(252,63,86,1);
    line-height:40px;
}
.topItemLeft_span2{
    margin-left: 4px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:40px;
}
.topItemRight{
     height: 100px;
     width: 530px;
     display: flex;
     flex-direction: row;
     align-items: center;
}
.selectItem_dot{
    width:36px;
    border-radius: 100%;
    height:36px;
    border:2px solid rgba(218,218,218,1);
}
.selectItem_icon{
     width:36px;
    border-radius: 100%;
    height:36px;
}
.selectItem_span{
    margin-left: 12px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:40px;
    margin-right: 40px;
}
.itemLine{
    margin-left: 220px;
    height: 2px;
    width:530px;
    background:rgba(234,234,234,1);
}
.kaipiaoMsg{
    margin-left: 28px;
    margin-top: 30px;
    height:36px;
    font-size:26px;
    font-weight:400;
    color:rgba(253,152,56,1);
    line-height:36px;
}
.input{
     height: 44px;
     width: 400px;
     font-size:28px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:44px;
     overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.closeDiv{
    height: 100px;
    width: 130px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
}
.closeImage{
    width: 44px;
    height: 44px;
    margin-right: 28px;
}
.itemButton{
     margin-top: 60px;
     width: 100%;
     flex-direction: row;
      display: flex;
}

.buttonGy{
     width:694px;
     height:88px;
     margin-left: 28px;
     background:rgba(218,218,218,1);
     border-radius:8px;
     font-size:32px;
     font-weight:400;
     color:rgba(255,255,255,1);
     line-height:88px;
     text-align: center;
}

.invoicebutton{

    width:694px;
    height:88px;
    margin-left: 28px;
    border-radius:8px;
    background:@color17;
    font-size:32px;
     font-weight:400;
     color:rgba(255,255,255,1);
     line-height:88px;
     text-align: center;
}

</style>